export const formatTimer = (
  days: number,
  hours: number,
  minutes: number,
  seconds: number,
  t: (key: string) => string
) => {
  if (days > 0) return `${days}${t("days")} ${hours}${t("hours")} `
  if (days === 0 && hours > 0)
    return `${hours}${t("hours")} ${minutes}${t("minutes")}`
  if (days === 0 && hours === 0 && minutes > 0)
    return `${minutes}${t("minutes")} ${seconds}${t("seconds")}`
  return `${seconds}${t("seconds")}`
}
